import { toast } from 'react-toastify';
import { ToastTypes } from 'common/types/toasts';

/**
 * Show toast notification. Inherits config from <ToastContainer> in app.tsx.
 * No per-call overrides of the look: all toasts use the global config (position, autoClose, etc.)
 * A `toastId` keeps one toast on screen when the same event repeats (a second
 * click on a button that can only answer with this message).
 */
export const showToast = (type: ToastTypes, message: string, toastId?: string) => {
  const options = toastId ? { toastId } : undefined;
  switch (type) {
    case ToastTypes.error: toast.error(message, options); break;
    case ToastTypes.warning: toast.warning(message, options); break;
    case ToastTypes.info: toast.info(message, options); break;
    case ToastTypes.success: toast.success(message, options); break;
    default: break;
  }
};
